import groq from 'groq'

export const modalTheoryGroq = groq`
*[_type == "encyclopediaStructure" && language == $language && htmlKey in $htmlKeys] {
  h1,
  htmlKey,
  cssUrl,
  htmlContent
}`

const isRootPathGroq = `count(*[references(^._id)]) == 0`

const siblingsGroq = `coalesce(*[_type == "encyclopediaStructure" && references(^._id)][0] {
  children[]-> {
    h1,
    path
  }
}.children,[])`

const nestedChildrenGroq = groq`children[]-> {
  h1,
  path,
  smallPreviewUrl,
  children[]-> {
    h1,
    path,
    smallPreviewUrl,
    children[]-> {
      h1,
      path,
      smallPreviewUrl,
      children[]-> {
        h1,
        path,
        smallPreviewUrl,
        children[]-> {
          h1,
          path,
          smallPreviewUrl
        },
      },
    },
  },
}`

const otherLocaleGroq = `*[_type == "encyclopediaStructure" && language != $language && path == $path] {
  locale,
}.locale`

// Self-join on sharedLanguageKey: translated siblings whose path differs per locale
// (same-path siblings are covered by otherLocales). defined() guards against a
// missing key matching every other keyless document. Includes self — the hreflang
// cluster needs the self-referencing entry.
const localeSiblingsGroq = `*[_type == "encyclopediaStructure" && defined(sharedLanguageKey) && sharedLanguageKey == ^.sharedLanguageKey]{ language, "slug": path }`

// `translated` resolves the requested-language sibling of the topic found at $path,
// so /no/<english-slug> can redirect to the NO translation instead of the EN page.
export const theoryAltLanguagePathGroq = groq`
coalesce(*[_type == "encyclopediaStructure" && language != $language && path == $path][0] {
    path,
    language,
    "translated": *[_type == "encyclopediaStructure" && language == $language && defined(sharedLanguageKey) && sharedLanguageKey == ^.sharedLanguageKey][0]{ path, language },
  },{})
`

export const theoryTopicFields = `
    key,
    sharedLanguageKey,
    path,
    title,
    type,
    h1,
    lastmod,
    locale,
    language,
    metaDescription,
    previewUrl,
    cssUrl,
    "htmlContent": {"html": htmlContent },
    breadcrumbs,
    "taskReference": *[_type == "mappingQuizTask" && references(^._id)][0]{
        taskId
    },
    "image": images[0],
    "siblings": ${siblingsGroq},
    "isRootPath": ${isRootPathGroq}`

export const theoryTopicGroq = groq`
coalesce(*[_type == "encyclopediaStructure" && language == $language && path == $path][0] {
${theoryTopicFields},
${nestedChildrenGroq},
"otherLocales": ${otherLocaleGroq},
"localeSiblings": ${localeSiblingsGroq}
  },{})`

export const theoryTopOverviewGroq = groq`
  *[_type == "encyclopediaStructure" && language == $language && type == $type && ${isRootPathGroq}][0] {
    "topicOverview": ${nestedChildrenGroq}
  }`

const isSlugMatch = `($path == source.path || source.path in $paths && source.slug)`

export const theoryRedirectTopicGroq = groq`
coalesce(*[_type == "pageRedirect" && source.language == $language && ${isSlugMatch}] | order(source.path desc) [0]  {
    source,
    destination,
  },{})`
